import { PageHeader } from '@/components/PageHeader/PageHeader.tsx'
import { Box, Button, Container } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { UserForm } from './-components/UserForm.tsx'
import { useCreateUser } from '@/features/user/hooks'
import { useTenant } from '@/contexts'

export const Route = createFileRoute('/_authenticated/$companySlug/users/create')({
  beforeLoad: ({ context }) => {
    context.auth.rejectIfMissingPermissions(['USER_READ', 'USER_WRITE'])
  },
  component: CreateUser
})

function CreateUser() {
  const { t } = useTranslation(['_routes', '_global', '@feature_user'])
  const { tenantId } = useTenant()
  const [successMessage, setSuccessMessage] = useState<string | null>(null)
  const [error, setError] = useState<Error | null>(null)

  const createUserMutation = useCreateUser({
    tenantId,
    onSuccess: async () => {
      setSuccessMessage(t('routes.users_create.main.messages.successMessage'))
      setError(null)
    },
    onError: err => {
      setError(err)
      setSuccessMessage(null)
    }
  })

  return (
    <Container maxWidth="xl" sx={{ py: 2, marginLeft: 0 }}>
      {/* Page Header */}
      <Box sx={{ mb: 4 }}>
        <PageHeader
          backArrow={{ to: '/$companySlug/users' }}
          subtitle={t('routes.users_create.main.description')}
        >
          {t('routes.users_create.main.title')}
        </PageHeader>
      </Box>

      <UserForm
        onSubmit={createUserMutation.mutate}
        successMessage={successMessage}
        error={error}
        onClearSuccess={() => setSuccessMessage(null)}
        onClearError={() => setError(null)}
        slots={{
          submit: props => (
            <Button {...props}>{t('routes.users_create.main.submit.available')}</Button>
          )
        }}
      />
    </Container>
  )
}
